'use es6';

import PropTypes from 'prop-types';
import { Children } from 'react';
import { useFilterEdit } from './FilterEditContext';
import SnowflakeFilterSeparator from './SnowflakeFilterSeparator';
import { useFiltering } from './SourceMeta';
import Immutable from 'immutable';

/**
 * Assumes report definition has been successfully loaded at call time.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useGroupCondition = groupIndex => {
  const {
    groups
  } = useFiltering();
  return groups.get(groupIndex).condition;
};
const ConnectedSeparator = ({
  groupIndex,
  readOnly
}) => {
  const [__, editCallbacks] = useFilterEdit();
  const condition = useGroupCondition(groupIndex);
  const handleConditionChange = nextCondition => {
    editCallbacks.handleGroupConditionChange(groupIndex, nextCondition);
  };
  return /*#__PURE__*/_jsx(SnowflakeFilterSeparator, {
    condition: condition,
    readOnly: readOnly,
    onChange: handleConditionChange
  });
};
const SnowflakeFilterGroupItem = ({
  showSeparator,
  readOnly,
  groupIndex,
  children
}) => /*#__PURE__*/_jsxs("div", {
  style: {
    position: 'relative'
  },
  children: [showSeparator && /*#__PURE__*/_jsx(ConnectedSeparator, {
    groupIndex: groupIndex,
    readOnly: readOnly
  }), children]
});
SnowflakeFilterGroupItem.propTypes = {
  showSeparator: PropTypes.bool.isRequired,
  groupIndex: PropTypes.number.isRequired,
  readOnly: PropTypes.bool,
  children: PropTypes.node
};
const SnowflakeFilterGroup = ({
  groupIndex,
  readOnly,
  children
}) => {
  const mapChild = (child, filterIndex) => /*#__PURE__*/_jsx(SnowflakeFilterGroupItem, {
    showSeparator: filterIndex !== 0,
    groupIndex: groupIndex,
    readOnly: readOnly,
    children: child
  }, filterIndex);
  return Children.map(children, mapChild);
};
SnowflakeFilterGroup.propTypes = {
  groupIndex: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.instanceOf(Array), PropTypes.instanceOf(Immutable.Iterable)])
};
export default SnowflakeFilterGroup;